
const ContactInfo = () => {
  const contactDetails = [
    {
      icon: 'ri-map-pin-line',
      title: 'Address',
      content: 'Doha, Qatar',
      link: null
    },
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      content: '1-800-555-0199',
      link: 'tel:+18005550199'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      content: 'info@flameguardqa.com',
      link: 'mailto:info@flameguardqa.com'
    },
    {
      icon: 'ri-time-line',
      title: 'Working Hours',
      content: 'Sunday – Thursday: 9:00 AM – 6:00 PM\nFriday – Saturday: Closed',
      link: null
    }
  ];

  return (
    <div className="bg-gray-50 rounded-lg p-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Contact Details</h2>
      
      <div className="space-y-6">
        {contactDetails.map((detail, index) => (
          <div key={index} className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className={`${detail.icon} text-xl text-red-600`}></i>
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-1">{detail.title}</h3>
              {detail.link ? (
                <a 
                  href={detail.link}
                  className="text-gray-600 hover:text-red-600 transition-colors"
                >
                  {detail.content}
                </a>
              ) : (
                <p className="text-gray-600 whitespace-pre-line">{detail.content}</p>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 pt-6 border-t border-gray-200">
        <h3 className="font-semibold text-gray-900 mb-4">Quick Links</h3>
        <div className="grid grid-cols-2 gap-3">
          <a href="/" className="text-gray-600 hover:text-red-600 transition-colors flex items-center">
            <i className="ri-home-line mr-2"></i>
            Home
          </a>
          <a href="/about" className="text-gray-600 hover:text-red-600 transition-colors flex items-center">
            <i className="ri-information-line mr-2"></i>
            About
          </a>
          <a href="/services" className="text-gray-600 hover:text-red-600 transition-colors flex items-center">
            <i className="ri-service-line mr-2"></i>
            Services
          </a>
          <a href="/products" className="text-gray-600 hover:text-red-600 transition-colors flex items-center">
            <i className="ri-product-hunt-line mr-2"></i>
            Products
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
